module.exports = __webpack_public_path__ + "img/workorder_nr2_1.e4654085.png";